import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SiteProvider, AuthProvider } from "@/context/AppContext";
import Layout from "@/components/site/Layout";
import Home from "@/pages/public/Home";
import { Treatments, Category, Treatment, Prices, NotFound } from "@/pages/public/Catalog";
import { About, Center, Contact, Faq, Guides, Guide, Glossary, Legal, SiteMap, Gallery } from "@/pages/public/Info";
import Booking from "@/pages/public/Booking";
import ManageBooking from "@/pages/public/ManageBooking";
import { Login, AcceptInvite, ForgotPassword, ResetPassword } from "@/pages/admin/AdminAuth";
import AdminLayout, { Dashboard } from "@/pages/admin/AdminLayout";
import CrudPage from "@/pages/admin/Crud";
import { CONFIGS } from "@/pages/admin/configs";
import Agenda from "@/pages/admin/Agenda";
import GalleryAdmin from "@/pages/admin/GalleryAdmin";
import { Users, Settings, Privacy, Audit, EmailOutbox, Account } from "@/pages/admin/System";
import OpeningDays from "@/pages/admin/OpeningDays";

const HIDDEN = ["guide", "redirect", "orari"];

function App() {
  return (
    <BrowserRouter>
      <SiteProvider>
        <AuthProvider>
          <Routes>
            <Route element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="chi-siamo" element={<About />} />
              <Route path="trattamenti" element={<Treatments />} />
              <Route path="trattamenti/:cat" element={<Category />} />
              <Route path="trattamenti/:cat/:slug" element={<Treatment />} />
              <Route path="listino-prezzi" element={<Prices />} />
              <Route path="galleria" element={<Gallery />} />
              <Route path="il-centro" element={<Center />} />
              <Route path="contatti" element={<Contact />} />
              <Route path="prenota" element={<Booking />} />
              <Route path="prenotazione/gestisci" element={<ManageBooking />} />
              <Route path="faq" element={<Faq />} />
              <Route path="guide" element={<Guides />} />
              <Route path="guide/:slug" element={<Guide />} />
              <Route path="glossario" element={<Glossary />} />
              <Route path="privacy" element={<Legal pageKey="privacy" fallbackTitle="Informativa privacy" />} />
              <Route path="cookie" element={<Legal pageKey="cookie" fallbackTitle="Cookie policy" />} />
              <Route path="termini" element={<Legal pageKey="termini" fallbackTitle="Termini e condizioni" />} />
              <Route path="mappa-del-sito" element={<SiteMap />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="admin/login" element={<Login />} />
            <Route path="admin/invito" element={<AcceptInvite />} />
            <Route path="admin/password-dimenticata" element={<ForgotPassword />} />
            <Route path="admin/reimposta-password" element={<ResetPassword />} />
            <Route path="admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="agenda" element={<Agenda />} />
              <Route path="apertura" element={<OpeningDays />} />
              <Route path="email" element={<EmailOutbox />} />
              <Route path="galleria" element={<GalleryAdmin />} />
              <Route path="impostazioni" element={<Settings />} />
              <Route path="utenti" element={<Users />} />
              <Route path="privacy" element={<Privacy />} />
              <Route path="registro" element={<Audit />} />
              <Route path="account" element={<Account />} />
              {Object.entries(CONFIGS).filter(([path]) => !HIDDEN.includes(path)).map(([path, cfg]) => <Route key={path} path={path} element={<CrudPage key={path} cfg={cfg} />} />)}
            </Route>
          </Routes>
          <Toaster position="top-right" />
        </AuthProvider>
      </SiteProvider>
    </BrowserRouter>
  );
}

export default App;
